<form [formGroup]="formGroup" id="step2Form">
  <div class="step2-form-container">
    <div class="row">
      <div class="nowrap-container">
        @if (controls.maritalStatus; as maritalStatus) {
          <div class="standard-form-field maritalStatus-field required-field">
            <label for="applicantMaritalStatus" [class.invalid]="maritalStatus.touched && maritalStatus.invalid">
              {{ 'PERSONAL_DATA_FORM.MARITAL-STATUS.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                id="applicantMaritalStatus"
                panelClass="standard-select"
                [placeholder]="'PERSONAL_DATA_FORM.MARITAL-STATUS.PLACEHOLDER' | translate"
                [formControl]="maritalStatus"
                (keydown)="firstInputKeydown($event)"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  maritalStatus.touched && maritalStatus.invalid ? 'applicantMaritalStatusError' : null
                "
                [attr.aria-invalid]="maritalStatus.touched && maritalStatus.invalid ? 'true' : null">
                @for (item of selectsValues.MARITAL_STATUS; track item) {
                  <mat-option [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                }
              </mat-select>
              <!-- ERROR -->
              @if (maritalStatus.touched && maritalStatus.invalid) {
                <mat-error id="applicantMaritalStatusError">
                  {{ maritalStatus.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (controls.education; as education) {
          <div class="standard-form-field education-field required-field">
            <label for="applicantEducation" [class.invalid]="education.touched && education.invalid">
              {{ 'PERSONAL_DATA_FORM.EDUCATION.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                id="applicantEducation"
                panelClass="standard-select"
                [placeholder]="'PERSONAL_DATA_FORM.EDUCATION.PLACEHOLDER' | translate"
                [formControl]="education"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="education.touched && education.invalid ? 'applicantEducationError' : null"
                [attr.aria-invalid]="education.touched && education.invalid ? 'true' : null">
                @for (item of selectsValues.EDUCATION; track item) {
                  <mat-option [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                }
              </mat-select>
              <!-- ERROR -->
              @if (education.touched && education.invalid) {
                <mat-error id="applicantEducationError">
                  {{ education.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      <div class="nowrap-container">
        @if (controls.pesel; as pesel) {
          <div class="standard-form-field pesel-field">
            <label for="peselInput" [class.invalid]="pesel.touched && pesel.invalid">
              {{ 'PERSONAL_DATA_FORM.PESEL.INFIELD-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                id="peselInput"
                matInput
                #peselInput
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                placeholder="{{ 'PERSONAL_DATA_FORM.PESEL.PLACEHOLDER' | translate }}"
                [required]="false"
                [attr.aria-required]="false"
                [attr.aria-describedby]="pesel.touched && pesel.invalid ? 'peselInputError' : null"
                [attr.aria-invalid]="pesel.touched && pesel.invalid ? 'true' : null"
                formControlName="pesel" />
              <!-- ERROR -->
              @if (pesel.touched && pesel.invalid) {
                <mat-error id="peselInputError">
                  {{ pesel.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (controls.telephoneNumber; as telephoneNumber) {
          <div class="standard-form-field telephoneNumber-field required-field">
            <label for="telephoneNumberInput" [class.invalid]="telephoneNumber.touched && telephoneNumber.invalid">
              {{ 'PERSONAL_DATA_FORM.TELEPHONE-NUMBER.INFIELD-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                id="telephoneNumberInput"
                matInput
                #telephoneNumberInput
                type="text"
                inputmode="tel"
                placeholder="{{ 'PERSONAL_DATA_FORM.TELEPHONE-NUMBER.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  telephoneNumber.touched && telephoneNumber.invalid ? 'telephoneNumberInputError' : null
                "
                [attr.aria-invalid]="telephoneNumber.touched && telephoneNumber.invalid ? 'true' : null"
                formControlName="telephoneNumber" />
              <!-- ERROR -->
              @if (telephoneNumber.touched && telephoneNumber.invalid) {
                <mat-error id="telephoneNumberInputError">
                  {{ telephoneNumber.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="nowrap-container">
        @if (controls.descriptionHeight; as descriptionHeight) {
          <div class="standard-form-field descriptionHeight-field required-field">
            <label
              for="applicantDescriptionHeight"
              [class.invalid]="descriptionHeight.touched && descriptionHeight.invalid">
              {{ 'PERSONAL_DATA_FORM.DESCRIPTION-HEIGHT.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                id="applicantDescriptionHeight"
                matInput
                type="number"
                inputmode="numeric"
                pattern="[0-9]*"
                min="50"
                max="280"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  descriptionHeight.touched && descriptionHeight.invalid ? 'applicantDescriptionHeightError' : null
                "
                [attr.aria-invalid]="descriptionHeight.touched && descriptionHeight.invalid ? 'true' : null"
                [formControl]="descriptionHeight"
                placeholder="{{ 'PERSONAL_DATA_FORM.DESCRIPTION-HEIGHT.PLACEHOLDER' | translate }}" />
              <!-- ERROR -->
              @if (descriptionHeight.touched && descriptionHeight.invalid) {
                <mat-error id="applicantDescriptionHeightError">
                  {{ descriptionHeight.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (controls.descriptionColourOfEyes; as descriptionColourOfEyes) {
          <div class="standard-form-field descriptionColourOfEyes-field required-field">
            <label
              for="applicantDescriptionColourOfEyes"
              [class.invalid]="descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid">
              {{ 'PERSONAL_DATA_FORM.DESCRIPTION-COLOUR-OF-EYES.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                id="applicantDescriptionColourOfEyes"
                panelClass="standard-select"
                [placeholder]="'PERSONAL_DATA_FORM.DESCRIPTION-COLOUR-OF-EYES.PLACEHOLDER' | translate"
                [formControl]="descriptionColourOfEyes"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid
                    ? 'applicantDescriptionColourOfEyesError'
                    : null
                "
                [attr.aria-invalid]="
                  descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid ? 'true' : null
                ">
                @for (item of selectsValues.EYES; track item) {
                  <mat-option [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                }
              </mat-select>
              <!-- ERROR -->
              @if (descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid) {
                <mat-error id="applicantDescriptionColourOfEyesError">
                  {{ descriptionColourOfEyes.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      @if (controls.descriptionSpecialMarks; as descriptionSpecialMarks) {
        <div class="standard-form-field widened-field descriptionSpecialMarks-field">
          <label
            for="applicantDescriptionSpecialMarks"
            [class.invalid]="descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid">
            {{ 'PERSONAL_DATA_FORM.DESCRIPTION-SPECIAL-MARKS.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantDescriptionSpecialMarks"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.DESCRIPTION-SPECIAL-MARKS.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-describedby]="
                descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid
                  ? 'applicantDescriptionSpecialMarksError'
                  : null
              "
              [attr.aria-invalid]="descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid ? 'true' : null"
              [formControl]="descriptionSpecialMarks" />
            <!-- ERROR -->
            @if (descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid) {
              <mat-error id="applicantDescriptionSpecialMarksError">
                {{ descriptionSpecialMarks.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
    <app-partial-residence-address
      [controls]="controls"
      [mode]="mode"
      [voivodeships$]="voivodeships$"
      [districts$]="districts$"
      [municips$]="municips$"
      [cities$]="cities$"
      [loadingDistricts$]="loadingDistricts$"
      [loadingMunicips$]="loadingMunicips$"
      [loadingCities$]="loadingCities$"
      [lookingForVoivodeship]="lookingForVoivodeship"
      [voivoIsBeeingUsed]="voivoIsBeeingUsed"
      [userACKDocumentsReset]="userACKDocumentsReset"
      [showDivider]="true"
      warningLayout="compact"
      voivodeshipSpinnerId="lookingForVoivodeshipSpinner"
      [voivodeshipSpinnerClass]="null"
      [voivodeshipSpinnerDiameter]="25"
      [trapVoivodeshipTab]="true"
      [trapWarningButtonTab]="true"
      (voivoChangeAcknowledged)="voivoChangeACK()"
      (lastFieldTabPressed)="lastFieldTabPressed.emit()">
    </app-partial-residence-address>
    <app-partial-origin-country-address [controls]="controls"> </app-partial-origin-country-address>
  </div>
</form>
